import styled, { keyframes } from 'styled-components'

import { helpers } from 'styles'

const fadeIn = keyframes`
	0% { opacity: 0; }
`

type Props = {
	isChecked: boolean
}

export const Container = styled.div<Props>`
	font-size: ${helpers.font.size.icon};
	cursor: pointer;
	position: relative;
	outline: 0;
	flex-shrink: 0;
	border: 1px solid ${({ theme }) => theme.color.inputCheckBorder};
	border-radius: 1em;
	width: 1em;
	height: 1em;
	background-color: ${({ theme, isChecked }) => (isChecked ? theme.color.inputCheckBorder : 'transparent')};
	transition: background-color ease-in 0.2s;

	> svg {
		animation: ${fadeIn} 0.2s;
		display: block;
		margin: -1px;
	}
`
